import { render, staticRenderFns } from "./SimTrading.vue?vue&type=template&id=748e4138&scoped=true"
import script from "./SimTrading.vue?vue&type=script&lang=js"
export * from "./SimTrading.vue?vue&type=script&lang=js"
import style0 from "./SimTrading.vue?vue&type=style&index=0&id=748e4138&prod&scoped=true&lang=css"
import style1 from "./SimTrading.vue?vue&type=style&index=1&id=748e4138&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e4138",
  null
  
)

export default component.exports